<template>
  <div>
    <!-- 主体信息 -->
    <el-card class="box-card box">
      <div
        class="dialoTitle"
        style="position: relative;"
      >
        <span style="font-size:15px;">主体信息</span>
        <el-button
          class="edit"
          @click="addSubject"
          :disabled="isOperate"
        >添加</el-button>
      </div>
      <div
        class="info"
        style="padding-top:0px!important"
      >
        <!-- 详情列表和编辑 -->
        <div
          class="empty-content"
          v-if="isShow=='1'"
        >
          <img
            src="@/assets/user_images/nothing.png"
            alt=""
            class="empty-img"
          >
          <div class="empty-desc">您还没有创建主体信息哦，快去添加吧！</div>
          <el-button
            type="primary"
            @click="addSubject"
            class="empty-add"
          >添 加</el-button>
        </div>
        <el-collapse
          v-if="isShow=='2'"
          v-model="activeNames"
          accordion
          @change="handleChange"
        >
          <template>
            <div
              v-for="(items,index) in subjectList"
              :key="index"
            >
              <el-collapse-item :name="index+1">
                <template slot="title">
                  <span> 主体名称：<span class="look">{{items.subjectName}}</span></span>
                  <el-button
                    class="edit"
                    :disabled="isOperate"
                    style="right:60px;top:12px"
                  >{{activeNames==(index+1)?'收起':'展开'}}</el-button>
                  <el-button
                    class="edit"
                    @click.stop="editSubject(items,index+1)"
                    :disabled="editSubjectTrans(index,items.type)"
                    style="right:0px"
                  >编辑
                  </el-button>
                </template>
                <el-form
                  :inline="false"
                  :model="subjectInfo"
                  class="demo-form-inline"
                  label-position="right"
                  label-width="100px"
                  ref="subjectInfo"
                  :rules="rules"
                  v-if="index==currentSubjectIndex"
                >
                  <el-row class="row">
                    <el-col :span="24">
                      <el-form-item
                        label="主体名称"
                        prop="subjectName"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.subjectName"
                          placeholder="请输入主体名称"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{subjectInfo.subjectName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="主体类型">
                        <span v-if="subjectInfo.type=='1'">企业</span>
                        <span v-if="subjectInfo.type=='2'">个人</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="开票单位"
                        prop="invoiceName"
                        v-if="subjectInfo.type==1"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.invoiceName"
                          placeholder="请输入开票单位"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{subjectInfo.invoiceName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="银行账号"
                        prop="payBank"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.payBank"
                          placeholder="请输入银行账号"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{subjectInfo.payBank}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="账户名称"
                        prop="payee"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.payee"
                          placeholder="请输入账户名称"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{subjectInfo.payee}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="开户行"
                        prop="openBankName"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.openBankName"
                          placeholder="请输入开户行"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{items.openBankName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="支行名称"
                        prop="branchBank"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.branchBank"
                          placeholder="请输入支行名称"
                        ></el-input>
                        <span
                          v-else
                          class="look"
                        > {{subjectInfo.branchBank}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="银行地址"
                        prop="bankAddressCity"
                      >
                        <el-select
                          v-if="isEditForm"
                          v-model="subjectInfo.bankAddressProvince"
                          placeholder="省"
                          @change="changeProvince(subjectInfo.bankAddressProvince,index)"
                          style="width:40%;"
                        >
                          <el-option
                            v-for="provinceItem in provinceList"
                            :key="provinceItem.region_code"
                            :label="provinceItem.region_name"
                            :value="provinceItem.region_name"
                          />
                        </el-select>
                        <el-select
                          v-if="isEditForm"
                          :key="keyValue"
                          v-model="subjectInfo.bankAddressCity"
                          placeholder="市"
                          @change="changeCity(subjectInfo.bankAddressCity,index)"
                          style="width:40%;"
                        >
                          <el-option
                            v-for="cityItem in cityList"
                            :key="cityItem.region_code"
                            :label="cityItem.region_name"
                            :value="cityItem.region_name"
                          />
                        </el-select>
                        <span
                          v-else
                          class="look"
                        >{{subjectInfo.bankAddressProvince}}{{subjectInfo.bankAddressCity}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="24"
                      v-if="isEditForm"
                    >
                      <el-form-item label="">
                        <div>
                          <el-button
                            type="primary"
                            @click="updateSubject('subjectInfo')"
                            style="color:#fff;background: #13c2c2;margin-right:10px;"
                          >保存</el-button>
                          <el-button @click="cancel">取消</el-button>

                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-collapse-item>
            </div>
          </template>
        </el-collapse>
        <!-- 添加 -->
        <div v-if="isAdd">
          <el-form
            :inline="false"
            :model="addSubjectInfo"
            class="demo-form-inline"
            label-position="right"
            label-width="100px"
            ref="addSubjectInfo"
            :rules="rules"
          >
            <div class="info">
              <el-row class="row">
                <el-col :span="24">
                  <el-form-item
                    label="主体类型"
                    prop="type"
                  >
                    <span v-show="false">{{addSubjectInfo.type}}</span>
                    <span class="see">企业</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="主体名称"
                    prop="subjectName"
                  >
                    <el-input
                      v-model="addSubjectInfo.subjectName"
                      placeholder="请输入主体名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="24"
                  v-if="addSubjectInfo.type==1"
                >
                  <el-form-item
                    label="开票单位"
                    prop="invoiceName"
                  >
                    <el-input
                      v-model="addSubjectInfo.invoiceName"
                      placeholder="请输入开票单位"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="银行账号"
                    prop="payBank"
                  >
                    <el-input
                      v-model="addSubjectInfo.payBank"
                      placeholder="请输入银行账号"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="账户名称"
                    prop="payee"
                  >
                    <el-input
                      v-model="addSubjectInfo.payee"
                      placeholder="请输入账户名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="开户行"
                    prop="openBankName"
                  >
                    <el-input
                      v-model="addSubjectInfo.openBankName"
                      placeholder="请输入开户行"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="支行名称"
                    prop="branchBank"
                  >
                    <el-input
                      v-model="addSubjectInfo.branchBank"
                      placeholder="请输入支行名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="银行地址"
                    prop="bankAddressCity"
                  >
                    <el-select
                      v-model="addSubjectInfo.bankAddressProvince"
                      placeholder="省"
                      @change="province"
                      style="width:40%;"
                    >
                      <el-option
                        v-for="provinceItem in provinceList"
                        :key="provinceItem.region_code"
                        :label="provinceItem.region_name"
                        :value="provinceItem.region_name"
                      />
                    </el-select>
                    <el-select
                      :key="keyValue"
                      v-model="addSubjectInfo.bankAddressCity"
                      placeholder="市"
                      @change="city"
                      style="width:40%;"
                    >
                      <el-option
                        v-for="cityItem in cityList"
                        :key="cityItem.region_code"
                        :label="cityItem.region_name"
                        :value="cityItem.region_name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="">
                    <el-button
                      type="primary"
                      @click="createSubjectInfo('addSubjectInfo')"
                      style="margin-right:10px;"
                    >保存</el-button>
                    <el-button @click="cancel('isAdd')">取消</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

          </el-form>
        </div>
      </div>
    </el-card>
  </div>

</template>

<script>
/*
salesmanList   商务业务员列表
provinceList  所有省数据
invoickList   支付主体
cityList    所有市数据
areaList      所有有区/县数据
flag  判断邮箱是否重复
*/
import jq from 'jquery'
import data from '@/api/getArea'
import { validateEmail, addBasicInfo, checkSubjectName } from "@/api/api"
import { validateTelphone, validateTelphoneUn, taxPointCheck } from "@/api/validate"
import { getDictList, getAuthFlag, getAddress, statusTrans } from "@/api/dataTrans"
import { getAllInfo, allMeijie, updateBasicInfo, updateReceiveInfo, addReceiveInfo, updateSubjectInfo, addSubjectInfo, getCreditLine, creditLine } from "@/api/siter.js"
import serve from "@/utils/request"
export default {
  data () {
    return {
      //默认0，1表示空，2表示非空
      isShow: 0,
      keyValue: 0,
      isEditForm: false, //  主体信息是否开启编辑
      currentSubjectIndex: 0,//当前展开主体窗口的数据下标
      creadit: null,
      salesmanName: null,
      isEdit: false,
      isAddReceive: false,
      isOperate: false,
      basicOperate: false,
      isAdd: false,
      isReceive: false,
      attributList: [],
      basicInfo: {
        name: null,
        email: null,
        linkman: null,
        telephone: null,
        salesmanId: null,
        detailAddress: null,
        city: null,
        area: null,
        provide: null
      },
      addreciveInfo: {
        recipients: null,
        receivePhone: null,
        receiveAddress: null,
      },
      submitData: {
        recipients: null,
        receivePhone: null,
        receiveAddress: null,
      },
      addSubjectInfo: {
        subjectName: null,
        type: 1,
        invoiceName: null,
        payBank: null,
        payee: null,
        openBankName: null,
        branchBank: null,
        bankAddressProvince: null,
        bankAddressCity: null,
        payBody: null
      },
      subjectInfo: {},
      subjectList: [],
      activeNames: [0],
      detail: "展开",
      retract: "收起",
      id: null,
      isDisabled: false,
      currentSubject: null,
      currentReceive: null,
      uId: null,
      salesmanList: [],
      provinceList: [],
      invoickList: [],
      cityList: [],
      areaList: [],
      flag: false,
      dialog: false,
      rules: {
        name: [{ required: true, validator: this.validateAdName, trigger: 'blur' }],
        email: [{ required: true, validator: this.validateMail, trigger: 'blur' }],
        linkman: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 20, message: '长度不能超过20', trigger: 'change' }
        ],
        telephone: [
          { required: true, validator: validateTelphone, trigger: 'change' }
        ],
        salesmanId: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        detailAddress: [
          { required: true, trigger: 'change' },
          { max: 80, message: '长度不能超过80', trigger: 'blur' }
        ],
        quantityLevel: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 300, message: '长度不能超过300', trigger: 'change' }
        ],
        scale: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 300, message: '长度不能超过300', trigger: 'change' }
        ],
        subjectName: [{ required: true, validator: this.valiateSubject, trigger: 'blur' }],
        type: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        taxPoint: [
          { required: true, validator: taxPointCheck, trigger: 'change' }
        ],
        payBank: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 40, message: '长度不能超过40', trigger: 'change' }
        ],
        payee: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 20, message: '长度不能超过20', trigger: 'change' }
        ],
        invoiceName: [{ required: true, message: '必选项不能为空', trigger: 'change' },
        { max: 40, message: '长度不能超过40', trigger: 'change' }],
        payBody: [{ required: true, message: '必选项不能为空', trigger: 'change' }],
        openBankName: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 40, message: '长度不能超过40', trigger: 'change' }
        ],
        branchBank: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 40, message: '长度不能超过40', trigger: 'change' }
        ],
        bankAddressCity: [{ required: true, message: '必选项不能为空', trigger: 'change' }],
        bankAddressProvince: [{ required: true, message: '必选项不能为空', trigger: 'change' }],
        recipients: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 20, message: '长度不能超过20', trigger: 'change' }
        ],
        receivePhone: [{ required: true, validator: validateTelphoneUn, trigger: 'change' }],
        receiveAddress: [{ required: true, max: 80, message: '长度不能超过80', trigger: 'change' }],
      },
      subjectId: 0
    }
  },
  mounted () {
    this.attributList = getDictList(207)
    // allMeijie().then(res => {
    //   if (res && res.code == 0) {
    //     this.salesmanList = res.data.items
    //   }
    // })
    // this.id = this.$route.query.userId
    //获取流量主所有信息
    this.getAll()
    // getCreditLine({
    //   trafficId: this.id
    // }).then(res => {
    //   if (res && res.code == 0) {
    //     this.creadit = res.data
    //   }
    // })
  },
  methods: {
    initData () {
      // 获取所有省份
      this.provinceList = data.data.items

    },
    transAddress (_p, _c, _a) {
      return getAddress(_p, _c, _a)
    },
    //详细地址转换
    addressTrans (_p, _c, _a, _d) {
      var _address1 = getAddress(_p, _c, _a)
      var _result = ''
      if (_d == null) {
        _result = _address1
      } else {
        _result = _address1 + _d
      }
      if (_result == null || _result == "") {
        _result == "--"
      }
      return _result
    },
    updateCreadit () {
      this.dialog = true
    },
    // handleClose () {
    //   this.dialog = false
    //   getCreditLine({
    //     trafficId: this.id
    //   }).then(res => {
    //     if (res && res.code == 0) {
    //       this.creadit = res.data
    //     }
    //   })
    // },
    //获取用户汇总信息
    getAll (_openIdx) {
      this.initData()
      getAllInfo().then(res => {
        if (res && res.code == 0) {
          this.id = res.data.trafficUserNewVO.id
          //流量主详情列表
          this.subjectList = res.data.trafficSubjectVOS
          if (this.subjectList.length > 0) {
            this.isShow = 2
          } else {
            this.isShow = 1
          }
          if (_openIdx) {
            this.activeNames = this.currentSubjectIndex + 1
          } else {
            this.currentSubjectIndex = this.subjectList.length - 1
            this.activeNames = res.data.trafficSubjectVOS.length
          }
          //当前单项主体信息
          this.subjectInfo = this.subjectList[this.currentSubjectIndex]
          this.getCityList()
        }
      })
    },
    //当前展开主体信息编辑按钮启禁用
    editSubjectTrans (_idx, _type) {
      // if(_type=='1'){
      //   if(this.currentSubjectIndex == _idx){
      //     return false
      //   }
      // }else{
      //   return false
      // }
      var _result = false
      if (this.currentSubjectIndex == _idx) {
        if (_type == '1') {
          _result = false
        } else {
          _result = true
        }
      } else {
        if (_type == '1') {
          _result = false
        } else {
          _result = true
        }
      }
      return _result
    },
    // 编辑基本信息
    editBasic () {
      this.isEdit = true
      this.isOperate = true
      this.basicOperate = true
      this.getCityList()
      this.getAreaList()
      this.changColor()
    },
    //取消操作
    cancel (val) {
      this.isEditForm = false
      this[`${val}`] = false
      this.isOperate = false
      this.basicOperate = false
      this.currentSubject = null
      this.currentReceive = null
      var arr = document.getElementsByClassName(' el-icon-arrow-right')
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.color = "#13c2c2"
      }
      this.getAll()
    },
    // 添加流量主主体信息
    createSubjectInfo (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.addSubjectInfo.userId = _this.id
          addSubjectInfo(_this.addSubjectInfo).then(res => {
            if (res && res.code == 0) {
              this.$message.success("添加成功")
              Object.assign(this.$data.addSubjectInfo, this.$options.data().addSubjectInfo)
              this.getAll()
              this.isOperate = false
              this.isAdd = false
            }
          })
        } else {
          return false;
        }
      })
    },
    // 编辑主体信息
    updateSubject (formName) {
      const _this = this
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          updateSubjectInfo(_this.subjectInfo).then(res => {
            if (res && res.code == 0) {
              // this.$message.success("更新成功")
              //初始化状态
              this.isEditForm = false
              this.isOperate = false
              this.currentSubject = null
              Object.assign(this.$data.addSubjectInfo, this.$options.data().addSubjectInfo)
            }
          })
          this.isOperate = false
        } else {
          return false;
        }
      })
    },
    // 新建收件信息
    createReceive (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.addreciveInfo.userId = _this.id
          addReceiveInfo(_this.addreciveInfo).then(res => {
            if (res && res.code == 0) {
              this.getAll()
              // this.$message.success("添加成功")
              Object.assign(this.$data.addreciveInfo, this.$options.data().addreciveInfo)
              this.isOperate = false
              this.isAddReceive = false
            }
          })
        } else {
          return false;
        }
      })
    },
    // 更新收件人
    updateReceive (formName, val) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateReceiveInfo(val).then(res => {
            if (res && res.code == 0) {
              this.$message.success("更新成功")
              this.isOperate = false
              this.currentReceive = null
            }
          })
        } else {
          return false;
        }
      })
    },
    // 更新基本信息
    updateBasicInfo (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateBasicInfo(this.basicInfo).then(res => {
            if (res && res.code == 0) {
              this.isOperate = false
              this.isEdit = false
              this.getAll()
            }
          })
        } else {
          return false;
        }
      })
    },
    addSubject () {
      if (this.isShow != 2) {
        this.isShow = 0
      }
      this.subjectId = 0
      this.isOperate = true
      this.isAdd = true
      this.changColor()
    },
    //编辑主体信息
    editSubject (val, idx) {
      const _this = this
      _this.activeNames = [idx]
      _this.subjectId = val.id
      _this.isEditForm = true
    },
    // 添加收件人
    addReceive () {
      //
      this.isAddReceive = true
      this.isOperate = true
      this.changColor()
    },
    // 编辑收件信息
    editReceive (val) {
      this.isOperate = true
      this.currentReceive = val
      this.changColor()
    },
    //空字符串转换
    emptyTrans (_val) {
      console.log(JSON.stringify(_val))
      if (_val == null || _val == undefined || _val == '') {
        return '--'
      } else {
        return _val
      }
    },
    handleChange (val) {
      if (val != "") {
        this.currentSubjectIndex = val - 1
        this.subjectInfo = this.subjectList[this.currentSubjectIndex]
      }
      this.isEditForm = false
      var eles = document.getElementsByClassName("operate")
      for (var i = 0; i < eles.length; i++) {
        if (parseInt(val - 1) == i) {
          eles[i].innerHTML = "收起"
        } else {
          eles[i].innerHTML = "展开"
        }
      }
    },
    // radioChange (value) {
    //   if (value == 2) {
    //     this.addSubjectInfo.taxPoint = 0.07
    //   } else if (value == 1) {
    //     this.addSubjectInfo.taxPoint = 0
    //   }
    // },
    //获取市级
    getCityList () {
      this.provinceList.forEach(item => {
        if (item.region_name == this.subjectInfo.bankAddressProvince) {
          this.cityList = item.children
        }
      })
    },
    // 选择省以后获取对应的市的数据
    changeCensusProvince () {
      this.basicInfo.city = null
      this.basicInfo.area = null
      this.getCityList()
    },
    province () {
      const _this = this
      this.addSubjectInfo.bankAddressCity = null
      this.provinceList.forEach(item => {
        if (item.region_name == this.addSubjectInfo.bankAddressProvince) {
          this.cityList = item.children
          this.keyValue = this.addSubjectInfo.bankAddressProvince
          _this.addSubjectInfo.bankAddressCity = _this.cityList[0].region_name
        }
      })
    },
    city () {
      this.cityList.forEach(item => {
        if (item.region_code == this.addSubjectInfo.bankAddressCity) {
          this.areaList = item.children
        }
      })
    },
    changeProvince (val, index) {
      // this.subjectInfo.subjectList[index].bankAddressCity = null
      this.provinceList.forEach(item => {
        if (item.region_name == val) {
          this.cityList = item.children
          this.subjectInfo.bankAddressCity = this.cityList[0].region_name
        }
      })
    },
    //获取县区列表
    getAreaList () {
      this.cityList.forEach(item => {
        if (item.region_name == this.basicInfo.city) {
          this.areaList = item.children
        }
      })
    },
    changeCity (val, index) {
      this.basicInfo.city = val
      // this.subjectInfo.subjectList[index].bankAddressCity = null
      this.getAreaList();
    },
    // 选择市以后获取对应的区的数据
    changeCensusCity () {
      this.basicInfo.area = null
      this.cityList.forEach(item => {
        if (item.region_code == this.basicInfo.city) {
          this.areaList = item.children
        }
      })
    },
    changColor () {
      var arr = document.getElementsByClassName(' el-icon-arrow-right')
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.color = "rgba(0,0,0,0.25)"
      }
    },
    //区县选择监听
    changeCensusCounty (_val) { },
    // 提交
    back () {
      this.$router.push('/userManage/siterManagement')
    },
    onSubmit (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true
          // 删除对象属性
          // this.$delete(this.submitData, 'taxPoint1');//vue方法
          // this.$delete(this.submitData, 'taxPoint2');//vue方法
          var parmas1 = {
            name: _this.submitData.name,
            email: _this.submitData.email,
            linkman: _this.submitData.linkman,
            telephone: _this.submitData.telephone,
            salesmanId: _this.submitData.salesmanId,
            province: _this.submitData.province,
            city: _this.submitData.city,
            area: _this.submitData.area,
            detailAddress: _this.submitData.detailAddress,
          }
          var parmas2 = {
            type: _this.submitData.type,
            taxReceipt: _this.submitData.taxReceipt,
            invoiceTitle: _this.submitData.invoiceTitle,
            invoiceAddress: _this.submitData.invoiceAddress,
            invoicePhone: _this.submitData.invoicePhone,
            payBank: _this.submitData.payBank,
            payBody: _this.submitData.payBody,
            openBankName: _this.submitData.openBankName,
          }
          var parmas3 = {
            recipients: _this.submitData.recipients,
            receivePhone: _this.submitData.receivePhone,
            receiveAddress: _this.submitData.receiveAddress,
          }
          addBasicInfo(parmas1).then(res => {
            if (res && res.code == 0) {
              _this.uId = res.data.id
              parmas2.userId = res.data.id
              parmas3.userId = res.data.id
              this.submitOthers(parmas2, parmas3)
            } else {
              // this.$message({
              //   type: 'error',
              //   message: res.msg
              // })
            }
          })

        } else {
          return false;
        }
      })

    },
    //提交主体收件信息
    submitOthers (val1, val2) {
      const _this = this
    },
    validateAdName (rule, value, callback) {
      const _this = this
      if (value == '' || value == null || value == undefined) {
        callback(new Error('必填项不能为空'))
      } else if (value.length > 20) {
        callback(new Error('长度不能超过20'))
      } else {
        checkAdName({ name: value, userRole: 2, }).then(res => {
          if (res && res.code == '0') {
            if (res.data) {
              callback(new Error('广告主名称已存在'))
            } else {
              callback()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 主体唯一性校验
    valiateSubject (rule, value, callback) {
      const _this = this
      if (value == '' || value == null || value == undefined) {
        callback(new Error('必填项不能为空'))
      } else if (value.length > 80) {
        callback(new Error('长度不能超过80'))
      } else {
        checkSubjectName({ name: value, userRole: 2, subjectId: this.subjectId }).then(res => {
          if (res && res.code == '0') {
            if (res.data.valid == true) {
              callback()
            } else {
              callback(new Error('主体名称已存在'))
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 校验邮箱账号
    validateMail (rule, value, callback) {
      if (value) {
        validateEmail({
          email: this.submitData.email
        }).then(res => {
          if (res && res.code == 0) {
            this.flag = res.data
            var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
            if (value == '' || value == null || value == undefined) {
              callback(new Error('邮箱不能为空'))
            } else if (value.length < 6 || value.length > 32) {
              callback(new Error('请输入6-32位的邮箱'))
            } else if (!re.exec(value)) {
              callback(new Error('邮箱格式不正确'))
            } else if (this.flag) {
              callback(new Error('邮箱不可以重复'))
            } else {
              callback()
            }
          }
        })
      } else {
        callback(new Error('邮箱不能为空'))
      }
    }
  }
}
</script>
<style scoped lang="scss">
/deep/.el-card__body {
  padding: 0px;
}

.changColor {
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 10px;
}

.info {
  padding: 32px 24px;
}

/deep/.row .el-form-item__content {
  width: 60%;
}
/deep/.address .el-form-item__content {
  width: 100px;
}

/deep/.detailAdd .el-form-item__content {
  width: 400px;
}

.back {
  margin: 16px 0px 0px 24px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  overflow: hidden;
}

.edit {
  color: rgba(19, 194, 194, 0.8);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 10px;
}

.edit:hover {
  background-color: #fff;
  color: #13c2c2;
}

/deep/.btnDisable {
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 16px;
}

/deep/.show {
  position: absolute !important;
  bottom: 8px !important;
  right: 100px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  padding: 24px 0px;
}

/deep/.el-button.is-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #ffffff !important;
}

.look {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
/deep/.receive .el-form-item {
  margin-bottom: 0px;
}

.receive {
  border-bottom: 1px solid #e9e9e9;
}

/deep/.operate {
  position: absolute !important;
  bottom: -28px !important;
  right: 80px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #14c2c2 !important;
  padding: 24px 0px;
  cursor: pointer;
}

/deep/.editOperate {
  position: absolute !important;
  bottom: 8px !important;
  right: 30px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #14c2c2 !important;
  padding: 24px 0px;
  cursor: pointer;
}

/deep/.el-collapse-item__header {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 14px !important;
  position: relative;
}

/deep/.el-collapse {
  border: none;
}

/deep/.el-collapse-item__wrap {
  background-color: #f8f8f8;
  padding-top: 30px;
}

/deep/.el-collapse-item__arrow {
  position: absolute;
  bottom: 14px;
  right: 42px;
  color: #13c2c2;
  font-size: 14px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -moz-transform: rotate(90deg);
  /* Firefox */
  -webkit-transform: rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  /* Opera */
}

/deep/.el-collapse-item__header .is-active {
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  /* IE 9 */
  -moz-transform: rotate(-90deg);
  /* Firefox */
  -webkit-transform: rotate(-90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
  /* Opera */
}

/deep/.el-form-item__label {
  font-weight: 600 !important;
}

/deep/.app-main {
  overflow-y: scroll;
}

/deep/.el-table td {
  text-align: center;
}

/deep/.el-table th {
  text-align: center;
}

.dialoTitle {
  padding: 28px 0px;
  font-size: 14px;
  color: #000;
  text-indent: 24px;
  font-weight: 500;
  border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
}
.is-disabled {
  background-color: none;
}
/deep/.el-form-item__label {
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
}

/deep/.el-select {
  width: 100%;
}

.address {
  display: flex;
  justify-content: center;
}
.empty-content {
  text-align: center;
  margin-top: 120px;
  .empty-img {
    width: 206px;
    height: 148px;
  }
  .empty-desc {
    margin-top: 40px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
  }
  .empty-add {
    margin-top: 16px;
  }
}
.edit {
  &:focus {
    background-color: #fff;
  }
}
</style>